import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllActivitiesByStudent } from 'domain/usecases';

export class RemoteGetAllActivitiesByStudent
  implements GetAllActivitiesByStudent
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllActivitiesByStudent.Result>,
  ) {}

  async execute(
    params: GetAllActivitiesByStudent.Params,
  ): Promise<GetAllActivitiesByStudent.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(this.url, {
        length: params.length,
        entity: params.entity,
        course: params.course,
        semester: params.semester,
        curricularUnit: params.curricularUnit,
        groups: params.group,
        starts: params.starts,
        ends: params.ends,
      }),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
